import { DatePipe } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolicitudRegistrarRenovacionDocumentoModel } from 'src/app/models/commands/solicitudes/solicitud-persona/SolicitudRegistrarRenovacionDocumentoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';

@Component({
  selector: 'app-solicitud-persona-renovar-documento-dialog',
  templateUrl: './solicitud-persona-renovar-documento-dialog.component.html',
  styleUrls: ['./solicitud-persona-renovar-documento-dialog.component.css'],
})
export class SolicitudPersonaRenovarDocumentoDialogComponent implements OnInit {
  constructor(
    private documentoPersonaService: SolicitudPersonaDocumentosService,
    public dialogRef: MatDialogRef<SolicitudPersonaRenovarDocumentoDialogComponent>,
    private datepipe: DatePipe,
    private alertDialogService: AlertDialogService,
    // private induccionService: InduccionService,
    @Inject(MAT_DIALOG_DATA)
    public model: SolicitudRegistrarRenovacionDocumentoModel
  ) {
    // this.model = new SolicitudRegistrarRenovacionDocumentoModel();
  }

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(form: NgForm, files: any) {
    // console.log(this.data.persona.documentos);
    if (!form.invalid) {
      // console.log("guardar");
      if (files.length === 0) {
        this.alertDialogService.open('Debe seleccionar un documento.');
        return;
      } else {
        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('codigo', this.model.codigoSolicutd);
        formData.append(
          'fechaVencimiento',
          `${this.datepipe.transform(
            this.model.fechaVencimiento,
            'yyyy-MM-dd'
          )}`
        );
        formData.append('comentarios', this.model.comentarios);
        console.log(this.model);
        this.documentoPersonaService
          .renovar(
            formData,
            this.model.idSolicitudPersonaDocumento,
            this.model.idSolicitud
          )
          .subscribe((event) => {
            if (event.type === HttpEventType.UploadProgress) {
              // this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event.type === HttpEventType.Response) {
              // this.filename = fileToUpload.name;
              // this.message = 'Upload success.';
              // this.model.nombreArchivo = fileToUpload.name;
              // this.onUploadFinished.emit(this.model);
              this.alertDialogService.open('Se ha enviado el documento renovado para validación');
              this.dialogRef.close();
            }
          });
      }
    }
  }
}
